export default __webpack_public_path__ + "static/media/signature.10fd333a.jpeg";